module.exports = __webpack_public_path__ + "static/media/points.2b3d416d.svg";